<template>
  <div>
    <a
      class="action-option"
      @click="updateCfdiStatus"
    >
      <BIcon
        icon="autorenew"
        class="action-option-icon"
      />
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UpdateCfdiStatus',
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      cfdiStatus: 'invoice/cfdiStatus',
    }),
    async updateCfdiStatus() {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'success',
        content: 'Actualizando estado de CFDI <br> Esperando respuesta, esto puede tomar un momento.',
        dateTime: now,
      });

      try {
        await this.cfdiStatus(this.invoice);
      } catch (error) {
        this.$store.commit('ui/deleteNotification', now);

        this.$danger({
          message: `
            Ocurrió un error al tratar de solicitar el estado de cancelación del Documento<br>
            ${error.message}
          `,
        });
      }

      this.$store.commit('ui/deleteNotification', now);

      this.$store.dispatch('addTemporalNotification', {
        type: 'success',
        content: 'El campo Estado CFDI fué actualizado',
      });
    },
  },
};
</script>
